import React from 'react';
import Checked from './../assets/icons/Checked.svg';
import './../css/premiummodal.scss';
import $ from 'jquery';
import { useHistory } from 'react-router';

export const SuccessRequestPremium = ({ pageChannel }) => {
  const history = useHistory();

  return (
    <div
      className="modal fade premium-modal"
      id="modal-success-request-premium"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-md" style={{ width: 500 }} role="document">
        <div className="modal-content">
          <div className="modal-body text-center">
            <img src={Checked} />
            <p className="mt-3 mb-3" style={{ fontSize: 17 }}>
              Pengajuan akun premium Anda akan diproses
            </p>
            <button
              onClick={() => {
                $('#modal-success-request-premium').modal('hide');
                history.replace({
                  pathname: '/',
                  state: {
                    pageChannel: pageChannel,
                  },
                });
              }}
              className="btn btn-overview-green-solid w-75"
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessRequestPremium;
